module.exports = require("./ar-MA");